import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'
import _imports_1 from '../../assets/images/logo-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-45b02d4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-img"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "logo-img1"
}, null, -1))
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "login-box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_8 = { class: "el-dropdown-link" }

import { defineComponent, reactive, Ref, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { apiStore } from '@/store/api'
  import yUser from '@/pages/user/index.vue'
  import mitt from '@/util/mitt'

  // 导航菜单
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const navList: Record<string, any>[] = reactive([
    {
      name: '首页',
      path: '/',
    },
    {
      name: '产品服务',
      path: '/product',
    },

    {
      name: '个人中心',
      path: '/personal',
    },
    // {
    //   name: '关于我们',
    //   path: 'about',
    // },
  ])
  const router = useRouter()
  const store = apiStore()

  // 导航菜单点击事件
  const handleNavClick = (data: Record<string, any>) => {
    const { path } = data
    const query = {}
    // const query = path == '/product' ? { id: 0 } : {}
    router.push({ path, query })
  }

  // 登录弹窗
  const showLogin = ref(false)
  const login = () => {
    showLogin.value = true
    loginComp.value = 'login'
  }

  const register = () => {
    showLogin.value = true
    loginComp.value = 'register'
  }
  // 动态组件
  const loginComp = ref('login')

  // 用户下拉菜单点击事件
  const handleCommand = (command: string | number | object) => {
    switch (command) {
      case '1':
        router.push('/personal')
        break
      case '2':
        store.userInfo = {}
        if (store.navActive == '/personal') {
          store.navActive = '/'
          router.push('/')
        }
        break
    }
  }

  // next
  const handleNext = (path: string, callback: Function) => {
    store.navActive = path.includes('/product') ? '/product' : path
    callback()
  }

  //
  const toPath = ref('')
  mitt.on('login', () => {
    const { query }: { query: any } = router.currentRoute.value
    router.push({ path: toPath.value, query })
    mitt.off('login')
  })

  mitt.on('showlogin', () => {
    login()
  })

  router.beforeEach((to, from, next) => {
    const { fullPath, path } = to
    if (fullPath == '/personal') {
      if (!store.userInfo.username) {
        toPath.value = '/personal'
        login()
      } else {
        handleNext(path, next)
      }
    } else {
      handleNext(path, next)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_router_link, {
        tag: "div",
        class: "logo",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass({ active: _unref(store).navActive == item.path }),
            onClick: ($event: any) => (handleNavClick(item))
          }, _toDisplayString(item.name), 11, _hoisted_5))
        }), 256))
      ]),
      (!Object.keys(_unref(store).userInfo).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "login",
              onClick: login
            }, "登录"),
            _hoisted_7,
            _createElementVNode("span", {
              class: "login",
              onClick: register
            }, "注册")
          ]))
        : (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 1,
            onCommand: handleCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { command: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("个人中心")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, { command: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("退出登录")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(store).userInfo.username) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
    ]),
    (showLogin.value)
      ? (_openBlock(), _createBlock(yUser, {
          key: 0,
          visible: showLogin.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showLogin).value = $event)),
          comp: loginComp.value,
          "onUpdate:comp": _cache[1] || (_cache[1] = ($event: any) => ((loginComp).value = $event))
        }, null, 8, ["visible", "comp"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})